import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { FacturaService } from 'src/app/services/factura.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { Uploads3Service } from 'src/app/services/uploads3.service';
import { GetAniosService } from 'src/app/services/get-anios.service';
import { SaberRolService } from 'src/app/services/saber-rol.service';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { NavigationService } from 'src/app/services/navigation.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { FormatoNumberService } from 'src/app/services/formato-number.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';
import { validacionRolService } from 'src/app/services/validacion-rol.service';
import { lastValueFrom } from 'rxjs';

import { MESES } from 'src/app/constants/months.const';


@Component({
  selector: 'app-facturas-d',
  templateUrl: './facturas-d.component.html',
  styleUrls: ['./facturas-d.component.css']
})
export class FacturasDComponent {

  @ViewChild('myModal') modalElement!: ElementRef; // ViewChild para acceder al elemento modal

  public files: NgxFileDropEntry[] = [];
  public hasBaseDropZoneOver = false;
  public filesGrouped: NgxFileDropEntry[][] = [];

  factura = {
    FKId_Proyecto: 0,
    FacPro_NomProyecto: '',
    FacPro_NoFactura: '',
    FacPro_Importe: 0,
    FacPro_FechaIngreso: '',
    FacPro_MesServicio: '',
    FacPro_AnoServicio: '',
    FacPro_FechaFacturacion: '',
    FacPro_Descripcion: '',
    FacPro_Observaciones: '',
    FacPro_VoBo: '',
    FacPro_ValidacionFecha: true,
    FacPro_Fecha_creacion: '' 
  }

  // Obtener la fecha actual
  currentDate: Date = new Date();

  // Definir la fecha mínima como el primer día del mes actual
  minDate: string = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1).toISOString().split('T')[0];

  // Definir la fecha máxima como el décimo día del mes actual
  maxDate: string = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 10).toISOString().split('T')[0];

  opE: any;
  proyectos: any[] = [];
  token: any;
  retrievedFactura: any;

  adjuntarFact = false;
  attachments: any[] = [];
  newdocuments: any[] = [];

  newDocument = {
    FKId_Factura: 0,
    FacDoc_NoFactura: 0,
    FacDoc_URL: '',
    FacDoc_Nombre: ''
  }

  //Parametros componet viewpdf
  pdfUrl: string = '';
  modalVisible: boolean = false;
  namepdf: string = '';
  //*

  loading = false; // Inicialmente, la carga está desactivada
  loadingDocuments = false;
  progressPercentage = 0;
  message = '';
  rol: any;

  usuarioId: any;

  // declaración de los mensajes de validación 
  showErrorMessageNoFac: boolean = false;
  showErrorMessageDesc: boolean = false;
  showErrorMessageProy: boolean = false;
  showErrorMessageIng: boolean = false;
  showErrorMessageMes: boolean = false;
  showErrorMessageImp: boolean = false;
  showErrorMessageFac: boolean = false;
  showErrorMessageAnio: boolean = false; 

  mensajeValidacionNoFac: string = '';
  mensajeValidacionDesc: string = '';
  mensajeValidacionProy: string = '';
  mensajeValidacionIng: string = '';
  mensajeValidacionMes: string = '';
  mensajeValidacionImp: string = '';
  mensajeValidacionFac: string = '';
  mensajeValidacionAnio: string = '';
  mensaje: string = 'Campo requerido.';

  validacionRol = '';
  nameBoton: string='';
  iconoMostrar: string = ''; 

  mostrarBtnFactura: boolean = false;
  mostrarBtnVoBo: boolean = false;
  validacionCampos: boolean = true;

  anios: string = '';

  meses = MESES;

  maxFechaHoy:any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private pagination: PaginationService,
    private UploadService: Uploads3Service,
    private requestsService: FacturaService,
    private getAniosService:GetAniosService,
    private catalogService: CatalogsService,
    private messagesService: MessagesService,
    private saberRolService: SaberRolService,
    private validacionBoton:validacionRolService,
    private navigationService: NavigationService,
    private formatoNumberService: FormatoNumberService,
    private filtrarProyectosService: FiltrarProyectosService) { }
    
  ngOnInit() {
    const hoy = new Date();
    this.maxFechaHoy = hoy.toISOString().split('T')[0]; 

    this.verificacionUsuario();
    this.obtnerIcono();
  }

  getYears(seleccion:string){
    this.getAniosService.obtenerAnios().subscribe(
      (data: any) => {
        this.anios = data;
          // Verifica si el año seleccionado ya está en la lista
          if(seleccion!== ''){
            if (this.anios.includes(this.factura.FacPro_AnoServicio)) {
              // Si el año existe, mantenemos el valor
              this.factura.FacPro_AnoServicio = seleccion;
            } else {
                console.warn("El año seleccionado no está en la lista de años disponibles.");
            }
          }

      }, (err) => {
        this.messagesService.showError(err.message);
      });
  }

  obtnerIcono(){
    this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
    this.nameBoton= this.opE === '1' ? 'Regresar' : 'Cancelar';
  }

  getFecha(){
    let fecha = new Date();

    let año = fecha.getFullYear();
    let mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
    let dia = String(fecha.getDate()).padStart(2, '0');
    let horas = String(fecha.getHours()).padStart(2, '0');
    let minutos = String(fecha.getMinutes()).padStart(2, '0');
    let segundos = String(fecha.getSeconds()).padStart(2, '0');

    this.factura.FacPro_Fecha_creacion = `${año}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
  }

  verificacionUsuario() {
    
    const { rol, usuarioId, token } = this.filtrarProyectosService.validacionUsuarios();
    this.token = token;
    this.usuarioId = usuarioId;
    this.rol = rol;
    
    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');
    
    if (this.opE === '1') {//obtendgo creditor para actualizar
      this.retrievedFactura = this.sharedService.getDataArray();
      this.cargarFactura(this.retrievedFactura);
          // Funcion que nos ayuda a validar los botones que se tienen quew mostrar
      this.mostrarBtnFactura = this.validacionBoton.validacionBotonEditar(this.rol, this.factura.FacPro_VoBo,this.opE,'Factura');
    }

    this.obtenerCatalogos();
    this.getYears('');
  }

  obtenerCatalogos() {
    this.catalogService.getAllProjects(this.token).subscribe(
      (data: any) => {
        if (this.rol === 'Administrador') {
          this.proyectos = data;
        } else {
          const { proyectosFiltrados } = this.filtrarProyectosService.filtrarProyectos(data, this.usuarioId);
          this.proyectos = proyectosFiltrados;
        }
      }, (err) => {
        this.messagesService.showError(err.message);
      });

  }

  esAdministrador(): boolean {
    if (this.rol === 'Administrador' && this.factura.FacPro_VoBo !== 'Aclaracion') {
      return false;
    } else {
      return true;
    }
  }

  async cargarFactura(getfactura: any) {

    this.factura.FacPro_VoBo = getfactura.FacPro_VoBo;
    this.factura.FacPro_Observaciones = getfactura.FacPro_Observaciones;
    this.factura.FacPro_ValidacionFecha = getfactura.FacPro_ValidacionFecha;
    this.factura.FKId_Proyecto = getfactura.FKId_Proyecto;
    this.factura.FacPro_NomProyecto = getfactura.FacPro_NomProyecto;
    this.factura.FacPro_NoFactura = getfactura.FacPro_NoFactura;
    // se obtiene el numero y se guarda en el FacPro_Importe
    this.factura.FacPro_Importe = getfactura.FacPro_Importe;
    this.factura.FacPro_FechaIngreso = this.obtenerFormatoFecha(getfactura.FacPro_FechaIngreso);
    this.factura.FacPro_MesServicio = getfactura.FacPro_MesServicio;
    const mesConFormato = this.factura.FacPro_MesServicio.charAt(0) + this.factura.FacPro_MesServicio.slice(1).toLowerCase();
    this.factura.FacPro_MesServicio = mesConFormato;
    this.factura.FacPro_Descripcion = getfactura.FacPro_Descripcion;

    
    
    if(getfactura.FacPro_AnoServicio!== null){
      this.factura.FacPro_AnoServicio = getfactura.FacPro_AnoServicio.trim();
      this.getYears(getfactura.FacPro_AnoServicio);
    }


    if(getfactura.FacPro_FechaFacturacion === null){
      this.factura.FacPro_FechaFacturacion = this.getCurrentDate();
    }else{
      this.factura.FacPro_FechaFacturacion = this.obtenerFormatoFecha(getfactura.FacPro_FechaFacturacion);
    }

    // se llama a la funcion que nos convierte los datos 
    this.facProImporteAsString();
    this.loadDocuments(getfactura.Id_Factura);

    // Funcion que nos ayuda a validar los botones que se tienen quew mostrar
    this.mostrarBtnFactura = this.validacionBoton.validacionBotonEditar(this.rol, this.factura.FacPro_VoBo,this.opE,'Factura');

    this.mostrarBtnVoBo = this.validacionBoton.validacionBotonVoBo(this.rol, this.factura.FacPro_VoBo,this.opE,'Factura');

    // Funcion que nos ayuda a poner disabled los input que se tienen que mostrar
    this.validacionCampos  = this.validacionBoton.validacionCampos(this.rol, this.factura.FacPro_VoBo,this.opE,'Factura');

    this.validacionRol = this.saberRolService.saberRol(getfactura, this.usuarioId);


  }

  loadDocuments(Id_Factura: any) {
    this.requestsService.getDocuments(Id_Factura, this.token).subscribe(
      (data: any) => {
        this.attachments = data;
      }, err => {
        this.messagesService.showError('Error al obtener los documentos.');
      });

  }

  getCurrentDate(): string {
    const today = new Date();
    return today.toLocaleDateString('en-CA'); // Formato YYYY-MM-DD
  }

  obtenerFormatoFecha(fecha: string): string {
    const fechaObj = new Date(fecha);
    const formatoFecha = fechaObj.toISOString().split('T')[0];
    return formatoFecha;
  }

  async validaFormulario(guardar: any, editar: any) {

    if (this.factura.FacPro_NoFactura === '') {
      return this.messagesService.showError('El No de Factura es obligatorio');
    }

    const proyecto = this.proyectos.find(proyecto => proyecto.Id_Proyecto === String(this.factura.FKId_Proyecto));

    if (proyecto === undefined) {
      return this.messagesService.showError('Seleccione un Proyecto');
    } else {
      this.factura.FacPro_NomProyecto = proyecto.Pry_Nombre
    }

    if (this.factura.FacPro_FechaIngreso === '') {
      return this.messagesService.showError('La Fecha de ingreso de facturación es obligatoria');
    }

    if (this.factura.FacPro_MesServicio === '') {
      return this.messagesService.showError('El Mes de servicio obligatorio');
    }

    if (this.factura.FacPro_AnoServicio === '') {
      return this.messagesService.showError('El Año de servicio obligatorio');
    }

    if (this.factura.FacPro_Importe === 0) {
      return this.messagesService.showError('El Importe obligatorio');
    }

    const totalArchivos = (this.newdocuments?.length || 0) + (this.attachments?.length || 0);

    if (totalArchivos <= 0) {
      return this.messagesService.showError('No se tienen facturas guardadas');
    }

    if (guardar === true) {
      this.guardar()
    }
    if (editar === true) {
      this.editar()
    }
  }

  guardarDatos(){
    this.getFecha();
    this.regresarNumero();
    this.factura.FacPro_NoFactura = this.factura.FacPro_NoFactura;
    this.factura.FacPro_Importe = Number(this.factura.FacPro_Importe);
    this.factura.FKId_Proyecto = Number(this.factura.FKId_Proyecto);
    this.message = "Guardando ...";
    this.loading = true;
  }

  guardar() {
    this.guardarDatos();

    this.requestsService.createfactura(this.factura, this.token).subscribe((res) => {
      if (this.newdocuments.length >= 1) {
        const facturaGuardada = this.obtenerFacturaGuardada(res);

        if (!facturaGuardada?.Id_Factura) {
          this.loading = false;
          this.messagesService.showError('No se pudo obtener el Id de la factura para guardar el documento.');
          return;
        }

        // Si almenos hay un documento realiza este proceso
        this.message = "Guardando Información y Documentos ....";
        this.newDocument.FKId_Factura = facturaGuardada.Id_Factura;
        this.newDocument.FacDoc_NoFactura = facturaGuardada.FacPro_NoFactura;
        this.uploadS3();
      } else {
        // Si no Existen Documentos
        this.loading = false;
        this.aceptar(res.message);
      }
    }, (err) => {
      this.loading = false;
      this.messagesService.showError(err.message);
    });
  }

  obtenerFacturaGuardada(res: any): any {
    return Array.isArray(res?.bill) ? res.bill[0] : res?.bill;
  }

  validarCamposVacios(){
    // Mapeo de nombres de campos a nombres amigables
    const campoNombres: { [key: string]: string } = {
      FKId_Proyecto: 'Proyecto',
      FacPro_NomProyecto: 'Nombre del proyecto',
      FacPro_NoFactura: 'Numero de factura',
      FacPro_Importe: 'Importe',
      FacPro_FechaIngreso: 'Fecha de ingreso',
      FacPro_MesServicio: 'Mes de servicio',
      FacPro_AnoServicio: 'Año de servicio',
      FacPro_FechaFacturacion: 'Fecha de facturación',
      FacPro_Descripcion: 'Descripción',
      FacPro_Observaciones: 'Observaciones',
      FacPro_VoBo: 'VoBo',
      // FacPro_ValidacionFecha: 'Validación de tiempo',
      FacPro_Fecha_creacion: 'Fecha Creación' 
    };
  

  // Verificar si algún campo de `this.factura` es null
  // const camposNulos: string[] = Object.entries(this.factura)
  //   .filter(([key, value]) => {
  //     // Excluir el campo `FacPro_ValidacionFecha` si el rol es "Administrador del proyecto"
  //     if (key === 'FacPro_ValidacionFecha' && this.rol === 'Administrador del proyecto') {
  //       return false; // No validar este campo
  //     }
  //     return value === null; // Validar si el valor es null
  //   })
  //   .map(([key]) => campoNombres[key] || key); // Mapea a nombre amigable o mantiene el original

  const camposNulos: string[] = Object.entries(this.factura)
  .filter(([key, value]) => {
    // ❌ Excluir este campo mientras no lo quieras validar
    if (key === 'FacPro_ValidacionFecha') return false;
    return value === null;
  })
  .map(([key]) => campoNombres[key] || key);

  if (camposNulos.length > 0) {
    // Si hay campos nulos, muestra cuáles son
    this.messagesService.showError(`Los siguientes campos están vacíos: ${camposNulos.join(', ')}`);
    return true; // Salir de la función si hay campos en null
  }

  return false;
  }
  
  
  editar() {
    // Validar los campos vacíos antes de proceder
    if (this.validarCamposVacios()) {
      return; // Si hay campos vacíos, termina la ejecución y no continúa con la edición
    }

    this.guardarDatos();

    if(this.rol === 'Administrador' && this.factura.FacPro_VoBo === 'VoBo'){
      this.factura.FacPro_VoBo = 'VoBo';
    }else if(this.rol === 'Administrador del proyecto' &&  this.factura.FacPro_VoBo === 'Aclaracion') { 
      this.factura.FacPro_VoBo = 'Pendiente';
    }

    this.requestsService.editfactura(this.factura, this.retrievedFactura.Id_Factura, this.token).subscribe(
      (res) => {
        if (this.newdocuments.length >= 1) {
          this.message = "Actualizando Información y Documentos ...."
          this.newDocument.FKId_Factura = this.retrievedFactura.Id_Factura;
          this.newDocument.FacDoc_NoFactura = this.retrievedFactura.FacPro_NoFactura;
          this.uploadS3();
        } else {
          this.loading = false;
          this.aceptar(res.message);
        }
      }, (err) => {
        this.messagesService.showError(err.message);
      }
    )
  }

  async uploadS3() {
    
    try {
      this.loadingDocuments = true;
      const totalDocuments = this.newdocuments.length;
      let processedDocuments = 0;
      
      for (const documento of this.newdocuments) {
        const urlFactura = await this.UploadService.uploadToS3('facturas', documento, this.newDocument.FKId_Factura);
        const nuevoDocumento = {
          ...this.newDocument,
          FacDoc_Nombre: documento.name,
          FacDoc_URL: urlFactura
        };

        await this.saveUrl(nuevoDocumento);
        processedDocuments++;
        this.progressPercentage = (processedDocuments / totalDocuments) * 100;
      }

      this.loadingDocuments = false;
      this.loading = false;
      this.aceptar("Factura y documentos Guardados")
    } catch (error: any) {
      this.loadingDocuments = false;
      this.loading = false;
      this.messagesService.showError(error?.message || 'No se pudo guardar la URL del documento.');
    }
  }

  async saveUrl(document: any) {
    await lastValueFrom(this.requestsService.SaveDocument(document, this.token));
  }

  // Esta Funcion remueve el documento localmente antes de guardarlo en base de datos
  quitDocument(indexToRemove: any) {
    this.newdocuments.splice(indexToRemove, 1);
  }

  deleteDocumentS3(document: any) {
    this.loading = true;
    this.message = "Eliminando Documento ...."
    this.UploadService.deleteFileS3('facturas', document.FKId_Factura, document.FacDoc_Nombre).then(
      (res: any) => {
        this.borrarDocumento(document, res);
      }, (error) => {
        this.loading = false;
        this.messagesService.showError(error);
        return;
      });

  }

  borrarDocumento(document: any, res: any) {
    this.requestsService.deleteDocument(document.Id_Documento, this.token).subscribe(
      (resp: any) => {
        this.loading = false;
        this.loadDocuments(this.retrievedFactura.Id_Factura)
        this.messagesService.showMessage(res);
      }, (error) => {
        this.loading = false;
        this.messagesService.showError(error);
      })
  }

  eliminar() {
    this.requestsService.deletefactura(this.retrievedFactura.Id_Factura, this.token).subscribe((res) => {
      this.aceptar(res.message);
    }, (err) => {
      this.messagesService.showError(err.message);
    })
  }

  private isNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  private isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (this.isPDF(file)) {
            const formData = new FormData();
            this.newdocuments.push(file);
          } else {
            this.messagesService.showError('El archivo no es un PDF.');
            console.error('Error: El archivo no es un PDF.');
            // Aquí puedes agregar lógica para notificar al usuario que solo se permiten archivos PDF.
          }
        });
      }
    }
  }

  private isPDF(file: File): boolean {
    return file.type === 'application/pdf';
  }

  comentarios() {
    if (this.factura.FacPro_Observaciones === '') {
      this.messagesService.showError('Es necesario colocar algún comentario.');
    } else {
      this.enviarComentario();
    }
  }

  enviarComentario() {
    const data = {
      FacPro_Observaciones: this.factura.FacPro_Observaciones, //string
      FacPro_VoBo: "Aclaracion" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.comentarios(data, this.retrievedFactura.Id_Factura, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      }, (err) => {
        this.messagesService.showError(err.message);
      }
    )
  }

  cambioEstatus() {
    const data = {
      FacPro_VoBo: "VoBo" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.cambioEstatus(data, this.retrievedFactura.Id_Factura, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      }, (err) => {
        this.messagesService.showError(err.message);
      }
    )
  }

  validarTiempo(boolean: any) {
    const data = {
      FacPro_ValidacionFecha: boolean
    }
    this.requestsService.ValidacionTiempo(data, this.retrievedFactura.Id_Factura, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      }, (err) => {
        this.messagesService.showError(err.message);
      }
    )
  }

  async openModal(document: any) {
    try {
      this.pdfUrl = await this.UploadService.getViewUrl('facturas', document.FKId_Factura, document.FacDoc_Nombre);
      this.namepdf = document.FacDoc_Nombre;
      this.modalVisible = true;
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo abrir el documento.');
    }
  }

  async downloadDocument(document: any) {
    try {
      const url = await this.UploadService.getViewUrl('facturas', document.FKId_Factura, document.FacDoc_Nombre);
      window.open(url, '_blank');
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo descargar el documento.');
    }
  }

  onModalClosed() {
    this.modalVisible = false;
  }

  aceptar(message: string) {
    this.messagesService.showMessage(message);
    this.cancelar();
  }

  cancelar() {
    this.pagination.setLastAction('back');
    this.router.navigate(['/facturas']);
  }

  public fileOver(event: any) {
    // console.log(event);
  }

  public fileLeave(event: any) {
   // console.log(event);
  }

  // regresar a numero 
  regresarNumero() {
    let ingresado = this.factura.FacPro_Importe;
    this.factura.FacPro_Importe = this.formatoNumberService.regresarNumero(ingresado);
  }

  // funcion que nos permite poner las comas en los digitos
  facProImporteAsString(): any {
    let ingresado = this.factura.FacPro_Importe;
    this.factura.FacPro_Importe = this.formatoNumberService.facProImporteAsString(ingresado);
  }

  // Método para filtrar caracteres no numéricos y puntos
  filterInput(event: any): void {
    let inputValue = event.target.value;

    // Permitir solo números y un solo punto decimal
    let sanitizedValue = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    // Verificar si el valor contiene un punto decimal
    if (sanitizedValue.indexOf('.') !== -1) {
      // Dividir el número en partes entera y decimal
      let partes = sanitizedValue.split('.');

      // Limitar la parte decimal a 2 dígitos
      let decimalPart = (partes[1] || '').substring(0, 2);

      // Formatear la parte entera con comas
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Unir la parte entera con la parte decimal
      sanitizedValue = `${partes[0]}.${decimalPart}`;
    } else {
      // Si no hay punto decimal, solo agregar comas a la parte entera
      sanitizedValue = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Actualizar el valor del campo
    event.target.value = sanitizedValue;
    this.facProImporteAsString();
  }

  // mensajes de validación 
  mostrarMensaje(campo: any, tipo: string) {
    switch (tipo) {
      case 'factura':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageNoFac = true;
          this.mensajeValidacionNoFac = this.mensaje;
        } else {
          this.showErrorMessageNoFac = false;
        }
        break;
      case 'descripcion':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageDesc = true;
          this.mensajeValidacionDesc = this.mensaje;
        } else {
          this.showErrorMessageDesc = false;
        }
        break;
      case 'proyecto':
        if (campo.dirty === false || campo.touched === true) {
          this.showErrorMessageProy = true;
          this.mensajeValidacionProy = this.mensaje;
        } else {
          this.showErrorMessageProy = false;
        }
        break;
      case 'ingreso':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageIng = true;
          this.mensajeValidacionIng = this.mensaje;
        } else {
          this.showErrorMessageIng = false;
        }
        break;
      case 'mes':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageMes = true;
          this.mensajeValidacionMes = this.mensaje;
        } else {
          this.showErrorMessageMes = false;
        }
        break;
        case 'anio':
          if (campo.invalid && (campo.dirty || campo.touched)) {
            this.showErrorMessageAnio  = true;
            this.mensajeValidacionAnio = this.mensaje;
          } else {
            this.showErrorMessageAnio = false;
          }
          break;
        // showErrorMessageAnio

        // showErrorMessageAnio
      case 'facturacion':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageFac = true;
          this.mensajeValidacionFac = this.mensaje;
        } else {
          this.showErrorMessageFac = false;
        }
        break;
      case 'importe':
        if ((campo.invalid && (campo.dirty || campo.touched)) || this.factura.FacPro_Importe === 0) {
          this.showErrorMessageImp = true;
          this.mensajeValidacionImp = this.mensaje || 'Importe no puede ser 0'; // Verifica que this.mensaje tenga un valor
        } else {
          this.showErrorMessageImp = false;
        }
        break;
    }
  }
}
